import { Loader2 } from "lucide-react";
import { brl, PEAK_FEE, PET_FEE } from "@/lib/pricing";

const Row = ({ l, v, testid }) => (
  <div className="flex justify-between gap-4 py-2 text-sm">
    <span className="text-[#cfd8c9]">{l}</span>
    <span data-testid={testid} className="text-right text-[#f3efe4]">
      {v}
    </span>
  </div>
);

export const ResumoPreco = ({ a, calc, form, loading, onSubmit }) => (
  <aside data-testid="booking-summary" className="grain relative bg-[#1a382b] p-6 text-[#f3efe4] sm:p-8">
    <p className="text-xs uppercase tracking-[0.24em] text-[#c8e39a]">Resumo da reserva</p>
    <p className="mt-2 text-2xl font-bold tracking-tight">{a.nome}</p>
    <div className="mt-6 divide-y divide-[#2f5040] border-y border-[#2f5040]">
      <Row l={`${calc.noites} ${calc.noites === 1 ? "diária" : "diárias"} × ${brl(a.preco)}`} v={brl(calc.subtotal)} testid="booking-price-subtotal" />
      {calc.especiais > 0 && <Row l={`Datas especiais (${calc.especiais} × ${brl(PEAK_FEE)})`} v={brl(calc.especiais * PEAK_FEE)} testid="booking-price-peak" />}
      {form.pet && calc.noites > 0 && <Row l="Pet" v={brl(PET_FEE)} testid="booking-price-pet" />}
      {calc.decoracao && calc.noites > 0 && <Row l={`Decoração ${calc.decoracao.nome}`} v={brl(calc.decoracao.preco)} testid="booking-price-decoration" />}
      <Row l="Pagamento" v={form.pagamento === "pix" ? "PIX" : `Cartão ${form.parcelas}x sem juros`} testid="booking-price-payment" />
    </div>
    <div className="mt-6 flex items-end justify-between">
      <span className="text-sm uppercase tracking-[0.2em] text-[#cfd8c9]">Total</span>
      <span data-testid="booking-price-total" className="text-4xl font-bold tracking-tight text-white">
        {brl(calc.total)}
      </span>
    </div>
    {form.pagamento === "cartao" && calc.total > 0 && (
      <p data-testid="booking-price-installment" className="mt-1 text-right text-sm text-[#c8e39a]">
        {form.parcelas}x de {brl(calc.total / Number(form.parcelas))} sem juros
      </p>
    )}
    {calc.noites === 0 && <p className="mt-4 text-sm text-[#e8c9b6]">Selecione check-in e check-out no calendário.</p>}
    <button
      type="button"
      onClick={onSubmit}
      disabled={loading}
      data-testid="booking-form-submit-button"
      className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-[#7ab51d] px-6 py-4 text-sm font-bold uppercase tracking-[0.16em] text-[#14291f] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#8cc92a] disabled:opacity-60"
    >
      {loading && <Loader2 className="h-4 w-4 animate-spin" />}
      Confirmar reserva
    </button>
    <p className="mt-4 text-center text-xs text-[#cfd8c9]">Sem pagamento online. Nossa equipe confirma pelo WhatsApp.</p>
  </aside>
);
